import{getUserData}from'@shopgate/pwa-common/selectors/user';/**
 * Selects the id of the currently logged in user or null if not logged in.
 * @param {Object} state The application state.
 * @returns {[number]}
 */export var getUserId=function getUserId(state){var userData=getUserData(state)||{};return userData.id||null;};/**
 * Selects the external customer number (ecp identifier)
 * of the currently logged in user or null if not logged in.
 * @param {Object} state The application state.
 * @returns {[number]}
 */export var getExternalCustomerNumber=function getExternalCustomerNumber(state){var userData=getUserData(state)||{};return userData.externalCustomerNumber||null;};